import React, { type FC } from "react";
import { useApiCall } from "../api/api";
import type { InspectionAttachment } from "../api/dto/InspectionAttachment";
import { ModalFooter } from "../components/layout/ModalProvider";

export const DeleteAttachmentModal: FC<{
  attachment: InspectionAttachment;
  onFinished?: () => void;
}> = (props) => {
  const { deleteAttachment } = useApiCall();

  const save = async () => {
    await deleteAttachment(props.attachment.inspectionId, props.attachment.id);
    props.onFinished?.();
  };
  return (
    <div>
      <p>
        <strong>Let op!</strong> Weet je zeker dat deze bijlage wilt verwijderen?
      </p>
      <p>
        Dit is een <strong>permanente</strong> actie en kan niet ongedaan worden gemaakt.
      </p>
      <ModalFooter text={"Verwijderen"} onSubmit={save} />
    </div>
  );
};
